class SchedulerService {
  constructor($rootScope, $http) {
    "ngInject";
    this.$rootScope = $rootScope;
    this.$http = $http;
  }

  getData(day) {
    return this.$http.get(this.$rootScope.config.api + 'programmplaner.php?day=' + day).then((result) => {
      return result;
    }, (response) => {
      console.error(response);
    });
  }

}

export default SchedulerService;



// WEBPACK FOOTER //
// ./client/app/common/scheduler/scheduler.service.js